import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  completedUploadCountSelector,
  completedUploadsSelector,
  failedUploadCountSelector,
  failedUploadsSelector,
  isLarge,
  removeUploadsAction,
} from '@air/redux-uploader';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { useAirSelector, useAirStore } from '~/utils/ReduxUtils';
import { sendAbortPrivateMultipartUpload } from '~/utils/uploadApi/privateUploadApi/privateLargeUploadApi';

export const useWorkspaceUploadsClearRecentUploads = () => {
  const dispatch = useDispatch();
  const store = useAirStore();
  const { currentWorkspace } = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;
  const completedCount = useAirSelector(completedUploadCountSelector);
  const failedCount = useAirSelector(failedUploadCountSelector);

  const hasClearableUploads = completedCount > 0 || failedCount > 0;

  const clearRecentUploads = useCallback(() => {
    const state = store.getState();
    const completedUploads = completedUploadsSelector(state);
    const failedUploads = failedUploadsSelector(state);
    const clearableUploadIds = [...completedUploads, ...failedUploads].map((upload) => upload.id);

    if (clearableUploadIds.length > 0) {
      dispatch(removeUploadsAction({ uploadIds: clearableUploadIds }));
    }

    if (workspaceId) {
      failedUploads.forEach((upload) => {
        if (isLarge(upload) && upload.s3Info.uploadUrlInfo) {
          void sendAbortPrivateMultipartUpload({ uploadUrlInfo: upload.s3Info.uploadUrlInfo, workspaceId });
        }
      });
    }
  }, [dispatch, store, workspaceId]);

  return {
    clearRecentUploads,
    hasClearableUploads,
  };
};
